import { Inject, Injectable, Injector, Type } from '@angular/core';
import { TuiDialogOptions, TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(
    @Inject(TuiDialogService)
    private readonly tuiDialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector,
  ) {}

  public async showComponentDialog<T extends object, G = void>(
    component: Type<T>,
    options?: Partial<TuiDialogOptions<any>>,
  ): Promise<G | undefined> {
    const dialog$ = this.tuiDialogService.open<G>(
      new PolymorpheusComponent(component, this.injector),
      {
        ...options,
      },
    );
    return lastValueFrom(dialog$, { defaultValue: undefined });
  }

  public async showHtmlDialog(
    content: string,
    options?: Partial<TuiDialogOptions<any>> | undefined,
  ): Promise<void> {
    const dialog$ = this.tuiDialogService.open<void>(content, {
      ...options,
    });
    return lastValueFrom(dialog$, { defaultValue: undefined });
  }
}
